import { render, staticRenderFns } from "./Jobs4.vue?vue&type=template&id=0b9fe74d"
import script from "./Jobs4.vue?vue&type=script&lang=ts"
export * from "./Jobs4.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports